import { render, staticRenderFns } from "./BasicCommand.vue?vue&type=template&id=688c8b0e&scoped=true&"
import script from "./BasicCommand.vue?vue&type=script&lang=ts&"
export * from "./BasicCommand.vue?vue&type=script&lang=ts&"
import style0 from "./BasicCommand.vue?vue&type=style&index=0&id=688c8b0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688c8b0e",
  null
  
)

export default component.exports